export default __webpack_public_path__ + "static/shield-vanderbilt-ef6378a456e3b272846ce7d0d769458e.svg";